import { RootState } from '@atredux/store'

export const getRoles = (state: RootState): string[] | undefined =>
    state.atRole._roles
